import { EntityId } from '@shared/models/entity-id';
export enum ExceptionType {
  authentication = 1,
  repository = 2,
  product = 3,
  order = 4,
  printer = 5,
  watermark = 6,
}

export enum UserGroup {
  admin = 'admin',
  owner = 'owner',
  staff = 'staff',
  supplier = 'supplier',
  customer = 'customer',
}

export enum UserStatus {
  inactive = 'inactive',
  pending = 'pending',
  active = 'active',
}

export enum UserAppearance {
  bright = 'bright',
  dark = 'dark',
  adaptive = 'adaptive',
}

export interface SignInFormControl {
  email: string;
  password: string;
  userSettings?: UserSettings;
}

export interface UserData {
  username?: string;
  phoneNumber?: string;
  firstname?: string;
  lastname?: string;
  patronymic?: string;
  email?: string;
  instagram?: string;
  media?: Array<{
    id: EntityId;
    url: string;
    type?: string;
    mime?: string;
  }>;
}

export interface Media {
  id: string;
  url: string;
  mime: string;
}

export interface UserSettings {
  localization: string;
  appearance: UserAppearance;
}

export interface SignInUserData {
  accountId: EntityId;
  status: UserStatus;
  group: UserGroup;
  passwordChangeRequired?: boolean;
  accessToken: string;
  refreshToken: string;
  userData: UserData;
  userSettings: UserSettings;
  error?: GeneralError;
}

export interface SignUpFormControl extends SignInFormControl {
  source: string;
  forcePasswordChangeOnFirstLogin?: boolean;
}

export interface NotificationSubscriptionRequest {
  platform: string;
  isMobile: boolean;
  subscription: PushSubscription;
}

export interface ValidationEmail {
  token: string;
}

export interface ValidationEmailResult {
  success: boolean;
}

export interface GeneralError {
  error: {
    detail: string;
  };
}

